// extracted by mini-css-extract-plugin
export var body = "_es-0";
export var sectionHeader = "_es-4";
export var shortcutColumns = "_es-2";
export var shortcutList = "_es-1";
export var shortcutSection = "_es-3";